import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class RoleManagementService {
  constructor(private httpClient: HttpClient) {}

  // ------------------- Function  Get -------------------
  public getMsRoleAll() {
    return this.httpClient.get<any[]>(
      `${environment.url}/apiMsRole/getMsRoleAll`
    );
  }

  public getMsMenuAll() {
    return this.httpClient.get<any[]>(
      `${environment.url}/apiMsMenu/getMsMenuAll`
    );
  }

  public getMsActionAll() {
    return this.httpClient.get<any[]>(
      `${environment.url}/apiMsMenu/getMsActionAll`
    );
  }

  public getDataEmployeeTypeAll() {
    return this.httpClient.get<any[]>(
      `${environment.url}/apiMsMenu/getDataEmployeeTypeAll`
    );
  }

  public getMsRoleById(id: any) {
    return this.httpClient.get<any[]>(
      `${environment.url}/apiMsRole/getMsRoleById/${id}`
    );
  }

  // ------------------- Function  Get Search -------------------
  public getRoleByFilter(roleName: string): Observable<any> {
    let params = new HttpParams();

    if (roleName != null) {
      params = params.append("roleName", roleName);
    }

    return this.httpClient.get<any>(
      "${environment.url}/apiMsRole/getRoleByFilter",
      { params: params }
    );
  }

  // ------------------- Function  Post -------------------
  public addMsRole(roleName: any, roleDesc: any, msRoleMenuModelList: any) {
    return this.httpClient.post<any>(
      `${environment.url}/apiMsRole/addMsRole`,
      {
        roleName,
        roleDesc,
        msRoleMenuModelList,
      }
    );
  }

  // ------------------- Function  Put -------------------
  public updateMsRole(
    id: any,
    roleName: any,
    roleDesc: any,
    msRoleMenuModelList: any
  ) {
    return this.httpClient.put<any>(
      `${environment.url}/apiMsRole/updateMsRole`,
      {
        id,
        roleName,
        roleDesc,
        msRoleMenuModelList,
      }
    );
  }

  // ------------------- Function  Delete -------------------
  public deleteMsRole(id: any) {
    let params = new HttpParams();
    if (id != null) {
      params = params.append("id", id);
    }
    return this.httpClient.delete<any>(
      `${environment.url}/apiMsRole/deleteMsRole/${id}`,
      { params: params }
    );
  }
}
